import React from "react";
import { useTranslation } from "react-i18next";

import { getFormattedEntity } from "helpers/chats";

import styles from "./styles.module.scss";

const Reply = ({ entity, onRemove }) => {
    const { t } = useTranslation();

    const handleReply = () => {
        onRemove();
    };

    return (
        <div className={styles.reply}>
            <div className={styles.reply__message}>
                {`${t("dialog.reply")} ${getFormattedEntity(t, entity)}`}
            </div>
            <button type="button" className={styles.reply__button} onClick={handleReply} />
        </div>
    );
};

export default Reply;
